export default "__VITE_ASSET__D9HvQ8FT__"